import axios from "axios";
import xlsx from "xlsx";
import { newUrl } from "../../utility";
import { SET_LOCATE_SITE_ARRAY, SET_LOCATE_SITE_MARKER_DATA } from "./types";

export const getSitesLatLong = site_code_array => dispatch => {
	axios
		.post(
			newUrl + "/getPlanoSitesData",
			{ site_code_array: site_code_array },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			result => {
				if (result.data.data) {
					dispatch({
						type: SET_LOCATE_SITE_ARRAY,
						payload: result.data.data
					});
				}
			},
			error => {
				console.log(error);
			}
		);
};

export const setLocateSitesMarkerData = site_id => dispatch => {
	dispatch({
		type: SET_LOCATE_SITE_MARKER_DATA,
		payload: {}
	});

	if (site_id) {
		axios
			.post(
				newUrl + "/get_site_details",
				{
					site_id: site_id
				},
				{ headers: { authorization: localStorage.getItem("plano_token") } }
			)
			.then((result, error) => {
				if (error) {
					console.log(error);
				} else {
					if (result.data.result) {
						dispatch({
							type: SET_LOCATE_SITE_MARKER_DATA,
							payload: result.data.result
						});
					}
				}
			});
	}
};

export const downloadPPT = (site_code_array, emails) => dispatch => {
	axios
		.post(
			newUrl + "/generatePlanoPPT",
			{ site_code_array: site_code_array, emails: emails },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					console.log("PPT request Sent");
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const generateLocateSiteExcel = locate_site_site_array => dispatch => {
	let headers = {
		site_code: "Site Code",
		city: "City",
		location: "Location",
		media_type: "Media Type",
		width: "Width",
		height: "Height",
		locality: "Locality",
		latitude: "Latitude",
		longitude: "Longitude",
		vendor: "Vendor",
		availability: "Availability",
		url: "URL"
	};

	let items = [];

	locate_site_site_array.map((item, index) => {
		const {
			site_code,
			city,
			location,
			media_type,
			width,
			height,
			locality,
			latitude,
			longitude,
			vendor,
			availability,
			site_map
		} = item;

		const url = site_map;

		items.push({
			[headers.site_code]: site_code ? site_code : "NA",
			[headers.city]: city ? city : "NA",
			[headers.location]: location ? location : "NA",
			[headers.media_type]: media_type ? media_type : "NA",
			[headers.width]: width ? width : "NA",
			[headers.height]: height ? height : "NA",
			[headers.locality]: locality ? locality : "NA",
			[headers.latitude]: latitude ? latitude : "NA",
			[headers.longitude]: longitude ? longitude : "NA",
			[headers.vendor]: vendor ? vendor : "NA",
			[headers.availability]: availability ? availability : "NA",
			[headers.url]: url
		});
		return null;
	});

	let dataWS = xlsx.utils.json_to_sheet(items, { headers: "test" });

	let wb = xlsx.utils.book_new();
	xlsx.utils.book_append_sheet(wb, dataWS, "SitesData");

	xlsx.writeFile(wb, "SitesData.xlsx");

	// exportCSVFile(headers, items, "SitesData");
};

// function convertToCSV(objArray) {
// 	var array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
// 	var str = "";

// 	for (var i = 0; i < array.length; i++) {
// 		var line = "";
// 		for (var index in array[i]) {
// 			if (line !== "") line += "\t";

// 			line += array[i][index];
// 		}

// 		str += line + "\r\n";
// 	}

// 	return str;
// }

// function exportCSVFile(headers, items, fileTitle) {
// 	if (headers) {
// 		items.unshift(headers);
// 	}

// 	// Convert Object to JSON
// 	var jsonObject = JSON.stringify(items);

// 	var csv = convertToCSV(jsonObject);

// 	var exportedFilenmae = fileTitle + ".csv" || "export.csv";

// 	var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
// 	if (navigator.msSaveBlob) {
// 		// IE 10+
// 		navigator.msSaveBlob(blob, exportedFilenmae);
// 	} else {
// 		var link = document.createElement("a");
// 		if (link.download !== undefined) {
// 			// feature detection
// 			// Browsers that support HTML5 download attribute
// 			var url = URL.createObjectURL(blob);
// 			link.setAttribute("href", url);
// 			link.setAttribute("download", exportedFilenmae);
// 			link.style.visibility = "hidden";
// 			document.body.appendChild(link);
// 			link.click();
// 			document.body.removeChild(link);
// 		}
// 	}
// }



// WEBPACK FOOTER //
// ./src/v3/actions/locateSitesActions.js